import { Component, signal } from "@angular/core";
import { DropdownMenuComponent, NavButtonComponent, SvgIconComponent, BtnActionEnum, CloseOnClickOutsideDirective } from "@evc/web-components";
import { TranslateService } from "@ngx-translate/core";
import { locales, LocaleOption } from "./locales";
import { LangUpdateService } from "../../../_services/lang-update.service";
import { LANGUAGE, LOCAL_STORAGE } from "../../../app.constants";

@Component({
  selector: "app-locale-selector",
  standalone: true,
  imports: [DropdownMenuComponent, NavButtonComponent, SvgIconComponent, CloseOnClickOutsideDirective],
  templateUrl: "./locale-selector.component.html",
  styleUrls: ["./locale-selector.component.scss"]
})
export class LocaleSelectorComponent {
  locales = locales;
  selectedLocale = signal<LocaleOption>(this.getSelectedLocale());
  isMenuOpen = signal(false);

  constructor(
    private langUpdateService: LangUpdateService,
    private translate: TranslateService
  ) {}

  private getSelectedLocale(): LocaleOption {
    const code = this.langUpdateService.getLang() || LANGUAGE.ENGLISH;
    return this.locales.find((l) => l.code === code) || this.locales[0];
  }

  get menuConfig() {
    return {
      items: this.locales.map((locale) => ({
        text: locale.label,
        key: locale.code,
        isDisabled: this.selectedLocale().code === locale.code,
        action: {
          type: BtnActionEnum.CALLBACK,
          callbackOrUrl: () => this.setSelectedLocale(locale)
        }
      }))
    };
  }

  toggleMenu(): void {
    this.isMenuOpen.update((isOpen) => !isOpen);
  }

  closeMenu(): void {
    this.isMenuOpen.set(false);
  }

  setSelectedLocale(locale: LocaleOption): void {
    const previousCode = this.selectedLocale().code;

    if (previousCode !== locale.code) {
      this.selectedLocale.set(locale);
      this.closeMenu();

      localStorage.setItem(LOCAL_STORAGE.LANGUAGE_PREFERENCE, locale.code);

      this.translate.use(locale.code).subscribe({
        next: () => {
          this.langUpdateService.updateLanguage(locale.code);
        }
      });
    } else {
      this.closeMenu();
    }
  }
}
